<!--
  Copyright 2023 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<h1 mat-dialog-title>{{ title }}</h1>

<mat-dialog-content [ngSwitch]="data.dialogType">
  <p *ngIf="content">{{ content }}</p>

  <mat-form-field *ngIf="[DialogType.AddJob, DialogType.RenameJob].includes(data.dialogType)">
    <mat-label i18n="@@app.forms.labels.jobName">Job name</mat-label>

    <input
      [id]="jobNameFieldId"
      matInput
      [(ngModel)]="data.jobName"
      [attr.maxlength]="jobNameMaxLength"
    />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <button
    mat-button
    color="primary"
    mat-dialog-close
    *ngIf="backButtonLabel"
  >
    {{ backButtonLabel }}
  </button>

  <button
    mat-button
    color="primary"
    [mat-dialog-close]="data"
    cdkFocusInitial
    *ngIf="continueButtonLabel"
  >
    {{ continueButtonLabel }}
  </button>
</mat-dialog-actions>
